import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'pcm-help',
	templateUrl: './help.component.html',
	styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
	@ViewChild('headerActions') headerActions;

	constructor(private location: Location,
		public configService: ConfigService) { }

	ngOnInit() { }


	closeHelp() {
		this.location.back();
	}
}
